import React, { useState, useEffect } from "react";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

export default function Admin() {
  const [token, setToken] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const t = localStorage.getItem("rl_admin_token");
    const exp = parseInt(localStorage.getItem("rl_admin_exp") || "0", 10);
    if (t && exp && Date.now() < exp) {
      setToken(t);
    } else {
      localStorage.removeItem("rl_admin_token");
      localStorage.removeItem("rl_admin_exp");
    }
    setReady(true);
  }, []);

  const handleLogin = (tok, expiresInSec) => {
    localStorage.setItem("rl_admin_token", tok);
    localStorage.setItem("rl_admin_exp", String(Date.now() + (expiresInSec || 86400) * 1000));
    setToken(tok);
  };

  const handleLogout = () => {
    localStorage.removeItem("rl_admin_token");
    localStorage.removeItem("rl_admin_exp");
    setToken(null);
  };

  if (!ready) return null;
  return token
    ? <AdminDashboard token={token} onLogout={handleLogout} />
    : <AdminLogin onLogin={handleLogin} />;
}
